export const ruid2uid = (ruid: string) => {
  // https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Operators/Exponentiation
  const shift = 2n ** 63n // 9223372036854775808n or 2ˆ63 in postgresql
  const uid = shift - BigInt(ruid)

  return uid.toString()
}
